import { useState } from 'react';
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';
import SubHeader from '../../Sub-Header/Sub-Header.jsx';
import ProductData from './product-data.json';
import styles from './Product.module.css';

import '../../../App.css';

function Product() {
	const products = [...ProductData].sort((a, b) =>
		a.name.localeCompare(b.name)
	);

	const [menuOpen, setMenuOpen] = useState(false);

	return (
		<>
			<HelmetProvider>
				<Helmet>
					<meta name="robots" content="noindex, nofollow" />
				</Helmet>
			</HelmetProvider>
			<SubHeader>
				<p>Product Information</p>
			</SubHeader>
			<div className='page-container'>
				<div className='desktop-padding' />
				<div className='page'>
					<div className={styles.container}>
						<div className={`${styles.menuBtnContainer} ${menuOpen ? styles.hide : ''}`}>
							<button
								className={styles.menuToggle}
								onClick={() => setMenuOpen(true)}
								aria-label="Toggle menu"
							>
								≡
							</button>
						</div>

						<div className={`${styles.sidebar} ${menuOpen ? styles.open : ''}`}>
							<button
								className={styles.closeButton}
								onClick={() => setMenuOpen(false)}
								aria-label="Toggle menu"
							>
								&#10007;
							</button>

							<div className={styles.linkList}>
								{products.map((product, index) => (
									<button
										key={index}
										className={styles.link}
										onClick={() => {
											setMenuOpen(false);
											const container = document.querySelector(`.${styles.scrollable}`);
											const target = document.getElementById(`item-${index}`);
											if (container && target) {
												container.scrollTo({
													top: target.offsetTop - container.offsetTop,
													behavior: 'smooth',
												});
											}
										}}
									>
										{product.name}
									</button>
								))}
							</div>
						</div>

						<div className={`${styles.content} ${styles.scrollable}`}>
							{products.map((product, index) => (
								<div
									key={index}
									id={`item-${index}`}
									className={styles.section}
								>
									<h4 className={styles.header}>{product.name}</h4>
									<p style={{ fontSize: '0.9rem' }}>{product.dietary.join(', ')}</p>

									{product.component.map((comp, compIndex) => (
										<div key={compIndex}>
											<br />
											<p className={styles.ingredientTitle}>{comp.type}</p>
											<p className={styles.ingredientList}>
												{comp.ingredients.map((ingredient, i) => {
													const isAllergen = product.allergens.some(allergen =>
														ingredient.toLowerCase().includes(allergen.toLowerCase())
													);

													return (
														<span key={i} className={styles.ingredientList}>
															{isAllergen ? <strong>{ingredient}</strong> : ingredient}
															{i < comp.ingredients.length - 1 ? ', ' : ''}
														</span>
													);
												})}
											</p>
										</div>
									))}
									<br />
									<p className={styles.allergenList}>
										Contains: <span className={styles.allergenItems}>{product.allergens.join(', ')}</span>
									</p>
									<br />
									<br />
									<hr />
								</div>
							))}
						</div>
					</div>
					<hr />
					<div className={`text-container ${styles.customTextContainer}`}>
						<p>Flours are milled in dedicated facilities free from gluten containing products.</p>
						<p style={{"marginTop": "10px"}}>Fats and oils are non-GM, mechanically processed, and contain no chemical solvents.</p>
					</div>
				</div>
				<div className='desktop-padding' />
			</div>
		</>
	);
}

export default Product;
